// extracted by mini-css-extract-plugin
module.exports = {"flash-click-overlay":"_1_wzA","flashClickOverlay":"_1_wzA"};